class networkService {
  headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  formatHeader = (headers) => {
    let configHeaders = this.headers;
    if (headers) {
      configHeaders = Object.assign({}, configHeaders, headers);
    }
    return configHeaders;
  };
  get = (url, headers = {}) => {
    return fetch(url, {
      headers: this.formatHeader(headers),
    }).then((response) => this.handleResponse(response));
  };

  delete = (url, headers = {}) => {
    return fetch(url, {
      method: "DELETE",
      headers: this.formatHeader(headers),
    }).then((response) => this.handleResponse(response));
  };

  put = (url, data, headers = {}) => {
    return fetch(url, {
      method: "PUT",
      headers: this.formatHeader(headers),
      body: JSON.stringify(data),
    }).then((response) => this.handleResponse(response));
  };

  patch = (url, data, headers = {}) => {
    return fetch(url, {
      method: "PATCH",
      headers: this.formatHeader(headers),
      body: JSON.stringify(data),
    }).then((response) => this.handleResponse(response));
  };

  post = (url, data, headers = {}) => {
    return fetch(url, {
      method: "POST",
      headers: this.formatHeader(headers),
      body: JSON.stringify(data),
    }).then((response) => this.handleResponse(response));
  };

  upload = (url, data) => {
    const headers = { Authorization: this.headers.Authorization };
    return fetch(url, {
      method: "POST",
      headers: headers,
      body: data,
    }).then((response) => this.handleResponse(response));
  };

  download = (url) => {
    const headers = { Authorization: this.headers.Authorization };
    return fetch(url, {
      method: "GET",
      headers: headers,
    }).then((response) => {
      if (response.ok) {
        return response.blob();
      } else {
        return response.json().then((value) => {
          return Promise.reject({
            status: response.status,
            response: value,
          });
        });
      }
    });
  };

  downloadFileViaPost = (url, data, headers = {}) => {
    return fetch(url, {
      method: "POST",
      headers: this.formatHeader(headers),
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.ok) {
        return response.blob();
      } else {
        return response.json().then((value) => {
          return Promise.reject({
            status: response.status,
            response: value,
          });
        });
      }
    });
  };

  setErrorPromise = (response, val) =>
    Promise.reject({
      status: response.status,
      response: val || response?.statusText || response,
    });

  handleResponse = (response) => {
    if (response.ok) {
      try {
        return response.json();
      } catch (e) {
        return response;
      }
    } else {
      try {
        return response.json().then((value) => {
          return this.setErrorPromise(response, value);
        });
      } catch (e) {
        if (e?.name?.startsWith("TypeError")) {
          return this.setErrorPromise(response);
        }
        return e;
      }
    }
  };

  setAccessToken(accessToken) {
    this.headers.Authorization = `Bearer ${accessToken}`;
  }

  deleteAccessToken() {
    this.headers.Authorization = ``;
  }

  postForm = (url, data, headers = {}) => {
    const formDataValues = new URLSearchParams();
    for (let property in data) {
      formDataValues.append(property, data[property]);
    }

    return fetch(url, {
      method: "POST",
      headers: this.formatHeader(headers),
      body: formDataValues,
    }).then((response) => this.handleResponse(response));
  };
}

export default new networkService();
